<template>
  <div class="notification-activity-table table-component p-2">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :search="tableData.search" :fields="tableFields"
                   :enable-simple-search="false" :index="false" :extra-data="extraData"
                   @paramsChanged="getTableData" filter-toggle-string="notification-activity-table">
      <template slot="cell(description)" slot-scope="{item}">
        {{ item.action | removeUnderscores | toUpperCaseFirstSentence}}
      </template>
      <template slot="cell(created_at)" slot-scope="{item}">
        {{ item.created_at | toDateTime }}
      </template>
      <template slot="cell(status)" slot-scope="{item}">
        <span v-if="item.result" v-as-status="item.result.status">
          {{ item.result.status | removeUnderscores | toUpperCaseFirst }}
        </span>
      </template>
      <template slot="cell(type)" slot-scope="{item}">
        <span v-as-status="item.type">
          {{ item.type | removeUnderscores | toUpperCaseFirst }}
        </span>
      </template>
      <template v-if="item.result" slot="cell(counts)" slot-scope="{item}">
        {{ item.result.failed }} / {{ item.result.successful }} / {{ item.total }}
      </template>
      <template slot="cell(actions)" slot-scope="{item}">
        <div style="min-height: 2em">
          <b-tooltip :target="`notification-activity-view-btn-${item.uuid}`" :title="$t('View')"/>
          <b-button :id="`notification-activity-view-btn-${item.uuid}`"
                    variant="primary" size="sm" class="mr-2" @click="onViewNotificationActivityClick(item)">
            <font-awesome-icon icon="eye"></font-awesome-icon>
          </b-button>
        </div>
      </template>
      <template v-slot:search-form-placeholder>
        <search-collapse table-id="notification-activity-table">
          <notification-activity-search :update-search-model="updateSearchModel" :get-table-data="getTableData"
                                 :vuex-search-model="tableData.searchModel"/>
        </search-collapse>
      </template>

    </artisio-table>
    <notification-activity-info-modal/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../core/components/ams-table/ArtisioTable";
  import i18n from "../../shared/i18n";
  import ActionButtons from "../../core/components/ams-table/ActionButtons";
  import SearchCollapse from "../../core/components/search-collapse/SearchCollapse";
  import NotificationActivitySearch from "@/modules/notification-activity/NotificationActivitySearch";
  import NotificationActivityInfoModal from "@/modules/notification-activity/NotificationActivityInfoModal";
  import {NOTIFICATION_ACTIVITY_TABLE_NAME} from "@/modules/constants";

  const {mapActions, mapState} = createNamespacedHelpers('notificationActivity');

  export default {
    name: "NotificationActivityTable",
    components: {NotificationActivitySearch, SearchCollapse, ActionButtons, ArtisioTable, NotificationActivityInfoModal},
    data() {
      return {
        tableFields: [
          {key: "description", label: i18n.t('Description'), sortable: true},
          {key: "type", label: i18n.t('Type'), sortable: true},
          {key: "display_name", label: i18n.t('Sender'), sortable: false},
          {key: "created_at", label: i18n.t('Date'), sortable: true},
          {key: "status", label: i18n.t('Status'), sortable: true},
          {key: "counts", label: i18n.t('Failed / Successful / Total'), sortable: false, tdClass: 'counts-td'},
          {key: "actions", label: i18n.t('Actions'), sortable: false}
        ],
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
        modal: state => state.modal,
      }),
      extraData() {
        return {
          tableName: NOTIFICATION_ACTIVITY_TABLE_NAME
        }
      }
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'showNotificationActivityInfoModal']),
      onViewNotificationActivityClick(item) {
        this.showNotificationActivityInfoModal({item});
      },
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  /deep/ .artisio-table {
    .counts-td {
      width: 15em;
    }
  }

</style>

